export class ScrollIntoView {
  // elementのスクロール位置をindex番目の子を表示する値に設定する
  // 子のサイズは一定とし、indexは0始まりとする
  static vertical(element: Element, index: number): void {
    if (!element.firstChild) {
      return;
    }
    const itemHeight = (element.firstChild as Element).clientHeight;
    const viewLow = element.scrollTop;
    const viewHigh = element.scrollTop + element.clientHeight;
    const currentLow = index * itemHeight;
    const currentHigh = (index + 1) * itemHeight;
    if (viewLow > currentLow) {
      element.scrollTop -= viewLow - currentLow;
    } else if (viewHigh < currentHigh) {
      element.scrollTop += currentHigh - viewHigh;
    }
  }
}
